export function useWindcaveScripts() {
    function loadScriptOnce(src: string) {
        return new Promise<void>((resolve, reject) => {
            if (document.querySelector(`script[src="${src}"]`)) {
                return resolve()
            }

            const script = document.createElement('script')
            script.src = src
            script.async = true
            script.onload = () => resolve()
            script.onerror = () => reject(new Error(`Failed to load ${src}`))
            document.head.appendChild(script)
        })
    }

    async function loadWindcaveHostedScripts() {
        await Promise.all(
            [
                'https://sec.windcave.com/js/lib/hosted-fields-v1.js',
                'https://sec.windcave.com/js/windcavepayments-hostedfields-v1.js'
            ].map(loadScriptOnce)
        )
    }

    return { loadWindcaveHostedScripts }
}
